import { useCallback, useEffect, useRef } from 'react';
import { fixedBody, looseBody } from '@/utils/fn';
import BScroll from '@better-scroll/core';
import { reportPopClick } from '@/utils/report';
import { ONLINE_STATUS_MAP } from '../config';
import EmptyData from './EmptyData';
import styles from '../styles/common.less';

const PAGE_NAME = 'invitee';

const InviteeDeviceOnlineModal = ({ visible, handleClose, data }) => {
  const bsScrollRef = useRef(null);

  const handleModalClose = useCallback(() => {
    handleClose();
    reportPopClick({
      page_name: PAGE_NAME,
      pop_name: 'online_pop',
      button_name: 'online_know',
    });
  }, [handleClose]);

  useEffect(() => {
    if (visible) {
      fixedBody();
    } else {
      looseBody();
    }
  }, [visible]);

  useEffect(() => {
    let bsScroll;
    if (data.length && bsScrollRef.current) {
      bsScroll = new BScroll(bsScrollRef.current);
    }
    return () => bsScroll?.destroy();
  }, [data]);

  return (
    <div className={`${styles.modal} ${visible ? styles.show : styles.hide}`}>
      <div
        className={`${styles.modalContent} ${styles.onlineContent}`}
        onClick={e => e.stopPropagation()}
      >
        <i
          className={`${styles['afont']} ${styles['icon-close']} ${styles.closeIcon}`}
          onClick={handleClose}
        />
        <h3 className={styles.modalHeader}>在线情况</h3>
        <div className={styles.modalBody}>
          <div className={styles.scrollContent} ref={bsScrollRef}>
            <div style={{ transform: visible ? '' : 'translateY(0)' }}>
              <ul className={`${styles.onlineList} ${styles.scrollbar}`}>
                {data?.length > 0 ? (
                  data.map((item, index) => (
                    <li key={index}>
                      <img className={styles.deviceImg} src={item.deviceicon} alt="logo" />
                      <div className={styles.onlineInfo}>
                        <p className={styles.sn}>{item.sn}</p>
                        <p
                          className={`${styles.status} ${
                            styles[`${ONLINE_STATUS_MAP[item.y_status].class}`]
                          }`}
                        >
                          {ONLINE_STATUS_MAP[item.y_status].text}
                        </p>
                      </div>
                      <div className={styles.days}>
                        <p className={styles.num}>{item.continous_day}天</p>
                        <p className={styles.text}>已累计在线</p>
                      </div>
                    </li>
                  ))
                ) : (
                  <EmptyData text="暂无绑定设备" className={styles.noDevice} />
                )}
              </ul>
            </div>
          </div>
          <div className={styles.onlineText}>
            <p>设备当日在线需满足：</p>
            <p>①当日在线≥20个小时；</p>
            <p>②高峰期（18点~24点）平均贡献带宽≥6M</p>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button onClick={handleModalClose}>知道了</button>
        </div>
      </div>
    </div>
  );
};
export default InviteeDeviceOnlineModal;
